import React from "react"

import {FormattedMessage} from "@irati/utils/lang"
import {Hr} from "@irati/ui/src/Layout"
import Occasion from "@irati/types"
import {Body} from "@irati/ui/src/Typography"
import Spacing from "@irati/ui/src/Spacing"

import ListItem from "./ListItem"

interface Props {
  description?: string,
  edit?: (occasion: Occasion) => void,
  items: Occasion[],
  hide: (occasion: Occasion) => void,
  show: (occasion: Occasion) => void
}

const OccasionsTab = ({items, description, hide, show, edit}: Props) => (
  <>
    {description &&
      <Spacing marginTop={4} marginBottom={4}>
        <Body>
          <FormattedMessage id={description} />
        </Body>
      </Spacing>
    }
    {items.map((item, i) => (
      <div key={i}>
        {i !== 0 && i !== items.length && <Hr />}
        <ListItem
          item={item}
          hide={hide}
          show={show}
          edit={edit} />
      </div>
    ))}
  </>
)

export default OccasionsTab
